import FieldController from '../field.controller';
import { isDateObject } from '../../../../../../lib/util';

class TimeFieldController extends FieldController {
  constructor($scope, $q, $translate, $log, DateTimeService, moment) {
    "ngInject";
    super($scope, $q, $translate, $log);
    this.moment = moment;

    this.DateTimeService = DateTimeService;
    this._timePickerOpened = false;
    this._timePickerOptions = {
    };
  }

  $onInit() {
    this.timeValue = this.value;
  }

  get timePickerOptions() {
    return this._timePickerOptions;
  }

  get timePickerOpened() {
    return this._timePickerOpened;
  }

  set timePickerOpened(opened) {
    this._timePickerOpened = opened;
  }

  get timeValue() {
    return this.rawValue;
  }

  set timeValue(dateValue) {
    this.rawValue = dateValue;
    if (dateValue) {
      this.value = this.moment(dateValue).format('h:mm a');
    }
  }

  openTimePicker() {
    this.timePickerOpened = true;
  }
}

export default TimeFieldController;
